import React from "react";
import pdf from "../../assets/AGBs_Diligent_Recruitment.pdf";

function AGB() {
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <object
        data={pdf}
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          PDF kann nicht angezeigt werden. <a href={pdf}>Hier herunterladen</a>.
        </p>
      </object>
    </div>
  );
}

export default AGB;
